export { useMediaQuery } from '@material-ui/core'

export const mobileSmallScreen = '(max-width: 360px)'
export const mobileScreen = '(max-width:480px)'
export const landscapeMobileScreen = '(max-width:767px)'
export const tabletScreen = '(max-width:991px)'
export const desktopScreen = '(min-width:991px)'
